import script from "./FoodMachine.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodMachine.vue?vue&type=script&setup=true&lang=js"

import "./FoodMachine.vue?vue&type=style&index=0&id=72e89bf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e89bf3"]])

export default __exports__